__turbopack_context__.v({
  "emailHeader": "EmailHeader-module-scss-module__Xjz_Wa__emailHeader",
  "emailHeader__content": "EmailHeader-module-scss-module__Xjz_Wa__emailHeader__content",
  "emailHeader__copy-container": "EmailHeader-module-scss-module__Xjz_Wa__emailHeader__copy-container",
  "floating": "EmailHeader-module-scss-module__Xjz_Wa__floating",
  "rotate": "EmailHeader-module-scss-module__Xjz_Wa__rotate",
  "stamp": "EmailHeader-module-scss-module__Xjz_Wa__stamp",
});
